(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-nxs-slider]').forEach(function(root){
      var track=root.querySelector('.nxs-hero__track'),slides=root.querySelectorAll('.nxs-hero__slide'),dots=root.querySelectorAll('.nxs-hero__dot');
      var i=0,n=slides.length,auto=parseInt(root.dataset.autoplay||'0',10),t;
      if(n<2)return;
      function go(k){i=(k+n)%n;track.style.transform='translateX(-'+(i*100)+'%)';dots.forEach(function(d,x){d.classList.toggle('is-active',x===i)})}
      var p=root.querySelector('[data-prev]'),nx=root.querySelector('[data-next]');
      function reset(){if(t)clearInterval(t);if(auto>0)t=setInterval(function(){go(i+1)},auto*1000)}
      if(p)p.addEventListener('click',function(){go(i-1);reset()});
      if(nx)nx.addEventListener('click',function(){go(i+1);reset()});
      dots.forEach(function(d,x){d.addEventListener('click',function(){go(x);reset()})});
      var sx=0;root.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
      root.addEventListener('touchend',function(e){var d=e.changedTouches[0].clientX-sx;if(Math.abs(d)>40){go(d<0?i+1:i-1);reset()}});
      go(0);reset();
    });

    document.querySelectorAll('[data-nxs-gallery]').forEach(function(g){
      var main=g.querySelector('[data-gal-main]'),thumbs=g.querySelectorAll('[data-gal-thumb]');
      thumbs.forEach(function(b){b.addEventListener('click',function(){
        thumbs.forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');
        var src=b.getAttribute('data-full'),alt=b.getAttribute('data-alt')||'';
        var img=main.querySelector('img');if(img&&src){img.src=src;img.removeAttribute('srcset');img.alt=alt}
      })});
    });

    document.querySelectorAll('[data-nxs-qty]').forEach(function(q){
      var inp=q.querySelector('input');
      q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
        var v=parseInt(inp.value||'1',10)+(b.dataset.step==='up'?1:-1);inp.value=Math.max(1,v)
      })});
    });

    document.querySelectorAll('[data-nxs-product]').forEach(function(root){
      var dataEl=root.querySelector('script[data-variants]');if(!dataEl)return;
      var variants=JSON.parse(dataEl.textContent),idInput=root.querySelector('[name=id]');
      var priceEl=root.querySelector('[data-price]'),compareEl=root.querySelector('[data-compare]'),addBtns=root.querySelectorAll('[data-add],[data-buy]');
      var fmt=root.getAttribute('data-money')||'Rs. {{amount}}';
      function money(c){var a=(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/,a)}
      function selected(){var o=[];root.querySelectorAll('[data-opt-group]').forEach(function(g){var a=g.querySelector('.is-active');o.push(a?a.dataset.value:null)});return o}
      function update(){
        var sel=selected(),v=variants.find(function(x){return x.options.every(function(val,idx){return val===sel[idx]})});
        if(!v){addBtns.forEach(function(b){b.disabled=true});return}
        idInput.value=v.id;
        if(priceEl)priceEl.textContent=money(v.price);
        if(compareEl){if(v.compare_at_price&&v.compare_at_price>v.price){compareEl.textContent=money(v.compare_at_price);compareEl.hidden=false}else{compareEl.hidden=true}}
        addBtns.forEach(function(b){b.disabled=!v.available;if(b.hasAttribute('data-add'))b.textContent=v.available?(b.dataset.label||'Add to cart'):(b.dataset.soldout||'Sold out')});
        var fi=v.featured_image&&v.featured_image.src;
        if(fi){var gm=root.querySelector('[data-gal-main] img');if(gm){gm.src=fi;gm.removeAttribute('srcset')}}
        if(history.replaceState&&root.dataset.updateUrl==='true'){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}
      }
      root.querySelectorAll('[data-opt-group]').forEach(function(g){
        g.querySelectorAll('[data-value]').forEach(function(b){b.addEventListener('click',function(){
          g.querySelectorAll('[data-value]').forEach(function(x){x.classList.remove('is-active')});b.classList.add('is-active');
          var lbl=g.querySelector('[data-opt-current]');if(lbl)lbl.textContent=b.dataset.value;update()
        })});
      });
    });

    var burger=document.querySelector('[data-nxs-burger]'),mob=document.querySelector('[data-nxs-mobnav]');
    if(burger&&mob)burger.addEventListener('click',function(){mob.classList.toggle('is-open')});
  });
})();
